import * as types from './mutations-types'

export default {
  [types.setChatOpened] (state, bool) {
    state.isOpened = bool
  },
  [types.setChatUser] (state, user) {
    state.user = user
  }
}



// WEBPACK FOOTER //
// ./src/domain/chat/store/mutations.js